export default __webpack_public_path__ + "static/navigation_w.8d4e8d7593097681a9fbd9b6d3a68e8d.svg";